var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',{staticClass:"daily-balance-widget"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"amount"},[_vm._v(_vm._s(_vm._f("number")(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }